import Swiper from 'swiper'
import { Pagination } from 'swiper/modules'

class CommunityServiceSwiper {
  swiper: Swiper

  constructor() {
    this.swiper = new Swiper('#prp-cs-swiper', {
      modules: [Pagination],
      slidesPerView: 1,
      slidesPerGroup: 1,
      centeredSlides: true,
      pagination: {
        el: '#prp-cs-swiper .swiper-pagination',
        clickable: true,
        bulletClass: 'w-3 h-3 rounded-full bg-white block shadow-md select-none cursor-pointer',
        bulletActiveClass: 'shadow-none !bg-black/50',
      },
    })
  }

  public init = (): void => {
    this.swiper.init()
  }
}

export default CommunityServiceSwiper
